import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/cultural-platform.css';

const OneSharedResponsibility = () => {
  return (
    <div className="article-page" data-testid="one-shared-responsibility-page" style={{ background: '#FFFFFF' }}>
      {/* Hero */}
      <section style={{
        padding: '120px 24px 80px',
        background: '#FFFFFF',
        borderBottom: '1px solid #DADCE0'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(36px, 5vw, 56px)',
            fontWeight: '400',
            color: '#202124',
            marginBottom: '24px'
          }}>
            One Shared Responsibility
          </h1>
          <p style={{
            fontSize: '18px',
            color: '#5F6368',
            lineHeight: '1.7'
          }}>
            A global people's movement for positive representation
          </p>
        </div>
      </section>

      {/* Article Content */}
      <section style={{ padding: '80px 24px', background: '#FFFFFF' }}>
        <article style={{ maxWidth: '720px', margin: '0 auto' }}>
          <div style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '18px',
            lineHeight: '1.9',
            color: '#202124'
          }}>
            <p style={{ marginBottom: '32px' }}>
              In a world where it has become easy to criticize our nations, to highlight only the flaws, 
              the failures, and the disappointments — Project Soft Power chooses a different path.
            </p>
            
            <div style={{
              background: '#F8F9FA',
              padding: '32px',
              borderRadius: '8px',
              marginBottom: '32px',
              textAlign: 'center'
            }}>
              <p style={{ 
                margin: 0,
                fontSize: '20px',
                color: '#202124'
              }}>
                We believe every country has imperfections.
                <br />But every country also has a soul.
              </p>
            </div>

            <p style={{ marginBottom: '32px' }}>
              We did not choose the land we were born in,
              just as we did not choose our parents.
              Yet we carry a responsibility to speak with pride, to act with dignity 
              and to represent our nation with truth, balance and humanity.
            </p>

            <div style={{
              background: '#1A73E8',
              color: '#FFFFFF',
              padding: '48px 32px',
              borderRadius: '8px',
              marginBottom: '32px',
              textAlign: 'center'
            }}>
              <p style={{ 
                margin: 0,
                fontSize: '22px'
              }}>
                If we don't speak positively about our country,
                <br />if we don't protect its story, culture, and identity —
              </p>
              <p style={{
                margin: '16px 0 0 0',
                fontSize: '32px',
                fontWeight: '500'
              }}>
                WHO WILL?
              </p>
            </div>

            <p style={{ marginBottom: '32px' }}>
              Project Soft Power is a global people's movement
              that encourages citizens to project their nations
              with confidence, gratitude, and creative strength — 
              not by denying flaws, but by standing tall despite them.
            </p>

            <p style={{ marginBottom: '32px' }}>
              Through arts, films, music and culture, we believe individuals become ambassadors.
              When one person lives with integrity, kindness, and pride, 
              their nation is reflected through them.
            </p>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '16px',
              marginBottom: '32px'
            }}>
              <div style={{
                background: '#F8F9FA',
                padding: '24px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <p style={{ margin: 0, fontWeight: '500' }}>This is not propaganda.</p>
              </div>
              <div style={{
                background: '#F8F9FA',
                padding: '24px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <p style={{ margin: 0, fontWeight: '500' }}>This is positive power.</p>
              </div>
              <div style={{
                background: '#F8F9FA',
                padding: '24px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <p style={{ margin: 0, fontWeight: '500' }}>This is soft power.</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: '48px',
            borderTop: '1px solid #DADCE0',
            marginTop: '48px'
          }}>
            <Link to="/what-is-soft-power" style={{
              color: '#1A73E8',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              ← Previous: What is Soft Power?
            </Link>
            <Link to="/arts-films-culture" style={{
              color: '#1A73E8',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              Next: Arts, Films & Culture →
            </Link>
          </div>
        </article>
      </section>
    </div>
  );
};

export default OneSharedResponsibility;
